import { useEffect } from "react";
// Lead-source attribution: SEO pages record where the lead came from; forms send it with the submission (playbook Phase 7).
// Keys: landing:{slug} · state:{state} · state-service:{state}:{service} · county:{state}:{county} · country:{country}:{slug} · location:{slug}
const KEY = "gd-lead-source";
export const setLeadSource = (v) => { try { sessionStorage.setItem(KEY, v); } catch { /* private mode */ } };
export const getLeadSource = () => { try { return sessionStorage.getItem(KEY) || ""; } catch { return ""; } };
export const useLeadSource = (v) => { useEffect(() => { if (v) setLeadSource(v); }, [v]); };
